import { Pipe, PipeTransform } from '@angular/core';
import { Application } from '../models/application';

@Pipe({
  name: 'applicationIcon',
})
export class ApplicationIconPipe implements PipeTransform {
  transform(application: Application): string {
    return application.getIcon();
  }
}
